import { CommonModule } from '@angular/common';
import { Component, inject, Input, signal, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IApiErrorResponse } from '@core/models';
import { ToastService, VerificaService } from '@core/services';

@Component({
  selector: 'app-contact-confirmation-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './contact-confirmation-modal.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './contact-confirmation-modal.css'
})
export class ContactConfirmationModalComponent {
  readonly activeModal = inject(NgbActiveModal);
  private readonly verificaService = inject(VerificaService);
  private readonly toastService = inject(ToastService);

  @Input() title = 'Conferma contatto';
  @Input() description =
    'Per completare la registrazione invia l\'email di conferma iscrizione.';
  @Input() showMaybeLater = false;
  @Input() showCloseButton = true;
  @Input() confirmAction: 'send_email' | 'emit' = 'send_email';
  @Input() profilo = '';

  readonly isConfirmingContact = signal(false);
  readonly confirmationCodeError = signal('');

  onConfirm(): void {
    if (this.confirmAction === 'emit') {
      this.activeModal.close('confirmed');
      return;
    }

    const currentProfilo = this.profilo.trim();
    if (!currentProfilo) {
      this.confirmationCodeError.set('Profilo non disponibile per inviare l\'email di conferma.');
      return;
    }

    this.isConfirmingContact.set(true);
    this.confirmationCodeError.set('');
    this.verificaService.richiediCodiceConfermaContatto('email').subscribe({
      next: () => {
        this.isConfirmingContact.set(false);
        this.toastService.presentaToastSuccess('Email di conferma iscrizione inviata con successo.');
        this.activeModal.close('confirmed');
      },
      error: (error: IApiErrorResponse | any) => {
        this.isConfirmingContact.set(false);
        const message = this.extractErrorMessage(error);
        this.confirmationCodeError.set(message);
        this.toastService.presentaToastErrore(message);
      }
    });
  }

  onMaybeLater(): void {
    this.activeModal.dismiss('maybe-later');
  }

  onClose(): void {
    this.activeModal.dismiss('closed');
  }

  private extractErrorMessage(error: IApiErrorResponse | any): string {
    if (error?.message) {
      return error.message;
    }

    if (error?.error?.message) {
      return error.error.message;
    }

    return 'Errore durante la conferma del contatto. Riprova.';
  }
}
